import { FuseAnimate } from '@fuse';
import _ from "@lodash";
import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/EmpresaPessoaFolgaActions';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    anotherLine: {
        backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#D4D4D4'
    }
});

class EmpresaPessoaFolgaList extends XAPPComponent {

    getItens = () => {
        const { EmpresaPessoaFolga } = this.props;
        var AResponse = [];
        if (!_.isUndefined(EmpresaPessoaFolga.data) && !_.isNull(EmpresaPessoaFolga.data)) {
            AResponse = EmpresaPessoaFolga.data;
        }
        return AResponse;
    }

    render() {

        const { save, xappRouteParams, classes, idparent, acaoRegistro, openDialog } = this.props;
        var bgColor = 0;
        const Columns = [
            {
                Header: "Repetir todos os anos",
                accessor: "repetir"

            },
            {
                Header: "Data",
                accessor: "formulario.datadescricao"
            },
            {
                Header: "Descrição",
                accessor: "formulario.descricao"
            },
            {
                Header: "Ações",
                accessor: "action"
            }
        ];

        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <Table className="min-w-full" aria-labelledby="tableTitle">
                        <TableHead>
                            <TableRow className="h-64">
                                {Columns.map(column => (
                                    <TableCell
                                        key={column.accessor}
                                        align={'center'}
                                        style={{ padding: '2px 12px 2px 12px' }}
                                    >
                                        {column.Header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.getItens().map(n => {
                                bgColor = bgColor === 0 ? 1 : 0;
                                return (
                                    <React.Fragment>
                                        <TableRow className={classNames("", bgColor === 1 && classes.anotherLine)} >
                                            {Columns.map(column => (
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    align={"center"}
                                                    style={{ padding: '2px 12px 2px 12px' }}
                                                >
                                                    {column.accessor === "action" ?
                                                        <div className="flex justify-center">
                                                            <XAPPButton
                                                                tooltip={{ "title": "Editar", "placement": "top" }}
                                                                className="mr-8"
                                                                icon={"edit"}
                                                                type={"icon"}
                                                                onClick={() => openDialog(n)}
                                                            />
                                                            <XAPPButton
                                                                tooltip={{ "title": "Remover", "placement": "top" }}
                                                                onClick={() => acaoRegistro(n, xappRouteParams, "INATIVAR", idparent)}
                                                                icon={"delete"}
                                                                type={"icon"}
                                                            />
                                                        </div>
                                                        :
                                                        column.accessor === "repetir" ?
                                                            <div className="flex justify-center">
                                                                <Checkbox
                                                                    color="primary"
                                                                    name="repetir"
                                                                    onClick={event => event.stopPropagation()}
                                                                    onChange={event => event.stopPropagation()}
                                                                    checked={n.formulario.repetir === 1}
                                                                    className={"cursor-default"}
                                                                />
                                                            </div>
                                                            :
                                                            column.accessor.split('.').reduce((o, k) => { return o && o[k]; }, n)
                                                    }
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </React.Fragment>
                                )
                            })}
                        </TableBody>
                    </Table>
                </FuseAnimate>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        acaoRegistro: Actions.acaoRegistro,
    }, dispatch);
}

function mapStateToProps({ EmpresaPessoaFolga }) {
    return {
        EmpresaPessoaFolga: EmpresaPessoaFolga,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaFolgaList)));
